import { makeStyles, Typography } from '@material-ui/core';
import DiscordLogo from '_assets/social/discord-logo.svg';
import DefaultButton from 'components/DefaultButton';
import { darken } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  button: {
    '&:hover': {
      backgroundColor: darken('#5865f2', 0.2),
    },
    marginTop: 10,
    backgroundColor: '#5865f2',
    color: theme.palette.common.white,
  },
  buttonText: {
    fontWeight: 'bold',
    marginRight: 10,
  },
}));

function DiscordButton({ alt = '', link, ...rest }) {
  const classes = useStyles();
  if (!link) return null;

  return (
    <DefaultButton onClick={() => {
      window.open(link, '_blank', 'noopener,noreferrer');
    }} className={classes.button} {...rest}>
      <Typography className={classes.buttonText}>REJOINDRE</Typography>
      <img alt={alt} src={DiscordLogo} width="20" height="20" />
    </DefaultButton>
  );
}

export default DiscordButton;
